<template>
  <div class="member-dialog">
    <el-dialog :visible.sync="dialog" :show-close="false" center>
      <!-- <span>需要注意的是内容是默认不居中的</span> -->
      <img
        src="https://cfb-bucket.oss-cn-beijing.aliyuncs.com/static/member.png"
        alt
        @click="show"
      />
      <span slot="footer" class="dialog-footer">
        <p>联系方式：</p>
        <p>全国电力行业CFB机组技术协作网</p>
        <p>循环流化床发电编辑部</p>
        <p>联系电话：010-68278970</p>
        <p>丰斌：13501066616</p>
        <p>
          网址：
          <a href="http://www.cfbchina.org.cn" target="_blank" rel
            >www.cfbchina.org.cn</a
          >
        </p>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      dialog: false
    }
  },
  methods: {
    show() {
      this.dialog = !this.dialog
    }
  }
}
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
@import '~assets/main.styl';

.member-dialog {
    >>>.el-dialog {
        width: 560px;
        // height: 404px;
        background: rgba(255, 255, 255, 1);
        box-shadow: 0px 4px 8px 0px rgba(31, 43, 77, 0.12);
        border-radius: 8px;
    }

    >>>.el-dialog__header {
        display: none !important;
    }

    >>>.el-dialog--center .el-dialog__body {
        padding: 0;
    }

    .dialog-footer {
        p {
            text-align: left;
            font-size: 14px;
            font-weight: 400;
            color: rgba(0, 0, 0, 0.65);
            line-height: 22px;
        }

        a {
            color: rgba(0, 0, 0, 0.65);
        }
    }

    img {
        width: 100%;
        height: 100%;
        border-radius: 8px;
    }
}
</style>
